<script>
  import { ComponentType } from '../../../../../../../../js/constants';
  import { getNavState } from '../../../../../../../../js/stores';
  import { blurOnClick } from '../../../../../../../../js/blurOnClick';
  import { getCategory, getSubcategory, getNavDeviceType } from '../../../../../../../../js/trackingUtils';
  import { trackCdp } from '../../../../../../../../js/tracking';

  import SubcategoryList from './SubcategoryList/SubcategoryList.svelte';

  export let id = undefined;
  export let title = undefined;
  export let description = undefined;
  export let navItems = [];

  const navStateStore = getNavState();
  const trackData = { menuId: id, menuText: title };

  let element;
  let isOpen = false;

  // When $navStateStore updates, if the current subcategory
  // is not this element, close this subcategory menu
  // to ensure only one subcategory is open at a time.
  $: if (isOpen && $navStateStore.subcategory !== element) {
    close();
  }

  function open() {
    isOpen = true;
    $navStateStore = { ...$navStateStore, subcategory: element };

    trackCdp({
      eventName: 'Open Menu',
      properties: {
        ...trackData,
        menuCategory: getCategory(element),
        menuSubcategory: getSubcategory(element),
        menuLocation: ComponentType.MAIN_NAVIGATION,
        navDeviceType: getNavDeviceType(element),
      },
    });
  }

  function close() {
    isOpen = false;
    trackCdp({
      eventName: 'Close Menu',
      properties: {
        ...trackData,
        menuCategory: getCategory(element),
        menuSubcategory: getSubcategory(element),
        navDeviceType: getNavDeviceType(element),
      },
    });
  }

  function onToggle() {
    isOpen ? close() : open();
  }
</script>

<div {id} class="Subcategory" class:isOpen data-subcategory={title} bind:this={element}>
  <button
    class="toggle nav-button"
    class:isOpen
    aria-haspopup="true"
    aria-expanded={isOpen ? true : false}
    use:blurOnClick
    on:click={onToggle}
  >
    <span class="title">{title}</span>
    {#if description}<span class="description">{description}</span>{/if}
  </button>
  <SubcategoryList {isOpen} {navItems} />
</div>

<style>@charset "UTF-8";
.Subcategory {
  margin: 0;
  padding: 0;
}

.toggle.nav-button {
  cursor: pointer;
  appearance: none;
  box-sizing: border-box;
  overflow: hidden;
  display: block;
  position: relative;
  width: 100%;
  margin: 0;
  padding: 0;
  outline: 0;
  border: 0;
  color: var(--color-text, #1a1a1a);
  font-family: "Square Sans Text VF", "Square Sans Text", "Helvetica", "Arial", "Hiragino Kaku Gothic Pro", "ヒラギノ角ゴ Pro W3", "メイリオ", meiryo, "ＭＳ Ｐゴシック", sans-serif;
  font-size: 16px;
  line-height: 28px;
  font-weight: 400;
  letter-spacing: normal;
  text-align: left;
  text-decoration: none;
  user-select: none;
  -webkit-user-drag: none;
  -webkit-tap-highlight-color: transparent;
  position: relative;
  overflow: hidden;
  -webkit-tap-highlight-color: transparent;
  padding: 12px 50px 12px 25px;
  background-color: transparent;
}
.toggle.nav-button::after {
  content: "";
  display: block;
  position: absolute;
  width: 8px;
  height: 8px;
  right: 35px;
  border-style: solid;
  border-width: 0;
  border-right-width: 2px;
  border-bottom-width: 2px;
  border-color: var(--color-text, #1a1a1a);
  transform: translate3d(50%, calc(-50% - 2px), 0) rotate(45deg);
  transition: transform 300ms cubic-bezier(0.4, 0, 0.2, 1);
  top: 26px;
}
.toggle.nav-button.isOpen::after {
  transform: translate3d(50%, calc(-50% + 2px), 0) rotate(-135deg);
}
.toggle.nav-button::-moz-focus-inner {
  border: 0;
}
.toggle.nav-button:focus {
  outline: none;
}
.toggle.nav-button::before {
  content: "";
  pointer-events: none;
  display: block;
  position: absolute;
  inset: 0;
  background-color: var(--color-highlight, rgba(26, 26, 26, 0.1));
  border-radius: 0;
  opacity: 0;
  transition: opacity 100ms cubic-bezier(0.4, 0, 0.2, 1), transform 100ms cubic-bezier(0.4, 0, 0.2, 1);
  transform: scale(0);
}
.toggle.nav-button:focus:not(:active)::before {
  opacity: 1;
  transform: scale(1);
}
.toggle.nav-button > * {
  position: relative;
}

.title {
  display: block;
  position: relative;
}
.isOpen .title {
  font-weight: var(--font-weight-medium, 500);
}

.description {
  display: block;
  position: relative;
  font-size: 12px;
  line-height: 22px;
  white-space: normal;
}</style>
